/**
 * Pedido anterior en menú demo (/menu/demo) — misma UX que localStorage en producción.
 */
import { readLastOrderForBusiness, saveLastOrder } from '@/lib/localLastOrder';
import { DEMO_BUSINESS_ID } from '@/lib/demo/demoConfig';
import {
  DEMO_BUSINESS,
  DEMO_CHECKOUT_DEFAULT_ADDRESS,
  DEMO_PRODUCTS,
  isDemoBusinessId,
} from '@/lib/demo/demoBusiness';

export function demoRepeatOrderSessionKey(businessId) {
  return `soluqr_repeat_order_prompt_dismissed_${businessId}`;
}

function demoProductById(id) {
  const p = DEMO_PRODUCTS.find((x) => x.id === id);
  return p ? { ...p } : null;
}

/** Pedido de ejemplo para capacitación (shape saveLastOrder / RepeatLastOrderDialog). */
export function buildDemoLastOrderSeed(business = DEMO_BUSINESS) {
  const smash = demoProductById('demo-prod-smash');
  const papas = demoProductById('demo-prod-papas-cheddar');
  const items = [];
  if (smash) {
    const unit = Number(smash.final_price ?? smash.price) || 0;
    items.push({
      product: { ...smash, final_price: unit },
      addOns: [],
      removedIngredients: [],
      quantity: 1,
      price: unit,
    });
  }
  if (papas) {
    const unit = Number(papas.final_price ?? papas.price) || 0;
    items.push({
      product: { ...papas, final_price: unit },
      addOns: [],
      removedIngredients: [],
      quantity: 1,
      price: unit,
    });
  }
  const total = items.reduce((s, line) => s + (Number(line.price) || 0) * (Number(line.quantity) || 1), 0);
  return {
    businessId: DEMO_BUSINESS_ID,
    businessName: business?.name || DEMO_BUSINESS.name,
    items,
    serviceType: 'delivery',
    total,
    createdAt: new Date(Date.now() - 2 * 86400000).toISOString(),
    paymentMethod: 'transfer',
    address: DEMO_CHECKOUT_DEFAULT_ADDRESS,
    customerName: 'María Demo',
    customerPhone: '56987654321',
  };
}

/**
 * Asegura que al abrir el menú demo aparezca el modal “Tu último pedido” (como en Pro).
 * @param {{ forceReseed?: boolean }} opts — forceReseed: siempre reescribe el pedido demo (capacitación).
 */
export function prepareDemoRepeatOrderPrompt(businessId, business, opts = {}) {
  if (!isDemoBusinessId(businessId)) return;
  const { forceReseed = true } = opts;
  try {
    sessionStorage.removeItem(demoRepeatOrderSessionKey(businessId));
  } catch {
    /* noop */
  }
  const biz = business || DEMO_BUSINESS;
  const existing = readLastOrderForBusiness(businessId, biz);
  if (forceReseed || !existing?.items?.length) {
    saveLastOrder(buildDemoLastOrderSeed(biz), businessId, biz);
  }
}
